import React from "react";
import Skeleton from "react-loading-skeleton";

import AppBox from "@/components/AppBox";
import AppTable from "@/components/AppTable";
import AppTableContainer from "@/components/AppTableContainer";
import AppTableHead from "@/components/AppTable/AppTableHead";
import AppTableBody from "@/components/AppTable/AppTableBody";
import AppTableRow from "@/components/AppTable/AppTableRow";
import AppTableCell from "@/components/AppTable/AppTableCell";
import AppTableHeaderCell from "@/components/AppTable/AppTableHeaderCell";

// Admin Users Table Skeleton
const AdminUsers: React.FC<{ rowCount?: number, loading?: boolean }> = ({ rowCount = 10, loading = false }) => (
  <AppTableContainer className={`absolute inset-0 transition-opacity ${loading ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
    <AppTable>
      <AppTableHead>
        <AppTableRow>
          <AppTableHeaderCell>Name</AppTableHeaderCell>
          <AppTableHeaderCell>Customer ID</AppTableHeaderCell>
          <AppTableHeaderCell>Email</AppTableHeaderCell>
          <AppTableHeaderCell>Agency Name</AppTableHeaderCell>
          <AppTableHeaderCell>Subscription</AppTableHeaderCell>
          <AppTableHeaderCell>Allow Access</AppTableHeaderCell>
          <AppTableHeaderCell>Agency</AppTableHeaderCell>
          <AppTableHeaderCell>Features</AppTableHeaderCell>
          <AppTableHeaderCell>Actions</AppTableHeaderCell>
        </AppTableRow>
      </AppTableHead>
      <AppTableBody>
        {Array.from({ length: rowCount }).map((_, idx) => (
          <AppTableRow key={idx}>
            <AppTableCell className="h-[151px] w-[262px]"><Skeleton width={200} height={20} /></AppTableCell>
            <AppTableCell className="w-[216px]"><Skeleton width={80} height={20} /></AppTableCell>
            <AppTableCell className="w-[340px]"><Skeleton width={230} height={20} /></AppTableCell>
            <AppTableCell className="w-[237px]"><Skeleton width={120} height={20} /></AppTableCell>
            <AppTableCell className="w-[140px]"><Skeleton width={20} height={20} /></AppTableCell>
            <AppTableCell className="w-[143px]"><Skeleton width={40} height={20} /></AppTableCell>
            <AppTableCell className="w-[97px]"><Skeleton width={40} height={20} /></AppTableCell>
            <AppTableCell className="w-[239px]">
              <Skeleton height={20} />
              <Skeleton height={20} />
              <Skeleton height={20} />
              <Skeleton height={20} />
            </AppTableCell>
            <AppTableCell>
              <AppBox gap={1}>
                <Skeleton width={20} height={20} />
                <Skeleton width={20} height={20} />
                <Skeleton width={20} height={20} />
              </AppBox>
            </AppTableCell>
          </AppTableRow>
        ))}
      </AppTableBody>
    </AppTable>
  </AppTableContainer>
);

// Admin Agencies Table Skeleton
const AdminAgencies: React.FC<{ rowCount?: number }> = ({ rowCount = 10 }) => (
  <AppTableContainer>
    <AppTable>
      <AppTableHead>
        <AppTableRow>
          <AppTableHeaderCell>Agency Name</AppTableHeaderCell>
          <AppTableHeaderCell>Email</AppTableHeaderCell>
          <AppTableHeaderCell>Admin</AppTableHeaderCell>
          <AppTableHeaderCell>Actions</AppTableHeaderCell>
        </AppTableRow>
      </AppTableHead>
      <AppTableBody>
        {Array.from({ length: rowCount }).map((_, idx) => (
          <AppTableRow key={idx}>
            <AppTableCell><Skeleton width="100%" height={20} /></AppTableCell>
            <AppTableCell><Skeleton width="100%" height={20} /></AppTableCell>
            <AppTableCell><Skeleton width="100%" height={20} /></AppTableCell>
            <AppTableCell><Skeleton width={100} height={20} /></AppTableCell>
          </AppTableRow>
        ))}
      </AppTableBody>
    </AppTable>
  </AppTableContainer>
);

// Export all skeletons under a common namespace
const TableSkeleton = {
  AdminUsers,
  AdminAgencies,
};

export default TableSkeleton;